import { Box, Select } from '@qonsoll/react-design'
import { DatePicker, Form } from 'antd'

import styled from 'styled-components'

export const filterBackground = [
  'var(--card-background)',
  'var(--card-background)',
  'var(--card-background)',
  'var(--card-background)'
]

export const iconStyles = { fontSize: '12px' }

export const filterMaxHeight = ['calc(100vh - 225px)', 'calc(100vh - 205px)']

export const buttonProps = {
  shape: 'circle',
  size: 'small',
  position: 'relative',
  left: 16,
  type: 'text'
}

export const StyledFilter = styled(Box)`
  display: flex;
  gap: 16px;
  border-radius: var(--ql-border-radius-default);
  margin-top: 16px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
  padding: 0px 32px 16px 32px;
  overflow: auto;
  width: 100%;
`
export const StyledDatePicker = styled(DatePicker)`
  width: 100%;
  max-width: 300px;
`
export const StyledSelect = styled(Select)`
  width: 100%;
  max-width: 300px;
`

export const FormStyled = styled(Form)`
  display: flex;
  align-items: center;
  width: 100%;

  .ant-form-item {
    margin: 0 !important;
    padding: 0 !important;
  }
`
